import React from "react";
import { Link } from "react-router-dom";
import Facebook from "../media/facebook-svg.svg";
import SVGComponent from "../navbar/svgviewer-react-output";
import "./footer.scss";

const FooterBar = () => {
  return (
    <footer className="footer">
      <div className="footer__grid container">

        <div className="footer__contact">
          <SVGComponent/>

          <p>Dworcowa 11,<br /> 62-090 Mrowino</p>

          <h3 className="footer__phone">
            <a  href="tel:+48535744816">+48 535 744 816</a>
          </h3>
          <div className="footer__socials">
            <img src={Facebook} alt="Facebook"></img>
            <a className="footer__socials-facebook" href="https://www.facebook.com/promotoserwis" target="_blank" rel="noopener noreferrer">
              FaceBook
            </a>
          </div>

          <p>Zapraszamy od poniedziałku do piątku<br /> w godzinach 08:00 - 16:30</p>

        </div>

        <div className="footer__links">
          <h4>Serwis</h4>
          <Link className="footer__links-link" to="/serwis-motocykli">Serwis motocykli</Link>
          <Link className="footer__links-link" to="/serwis-quadow">Serwis quadów</Link>
          <Link className="footer__links-link" to="/serwis-skuterow">Serwis skuterów</Link>
          <Link className="footer__links-link" to="/przeglady-techniczne">Przeglądy techniczne</Link>
        </div>

        <div className="footer__links">
          <h4>Pozostałe usługi</h4>
          <Link className="footer__links-link" to="/transport-motocykli">Transport motocykli</Link>
          <Link className="footer__links-link" to="/doradztwo">Doradztwo podczas zakupu</Link>
          <Link className="footer__links-link" to="/skup">Skup motocykli</Link>
          <Link className="footer__links-link" to="/polityka-prywatności">Polityka prywatności</Link>
          <Link  to="/motocykle" className="footer__links-btn">
            AKTUALNE OFERTY
          </Link>
        </div>
      </div>
      <div className="footer__copy">
        © 2015 - {new Date().getFullYear()} PRO MOTO — warsztat motocyklowy Mrowino
      </div>
    </footer>
  );
};

export default FooterBar;
